import React from 'react';
import { CalendarDaysIcon, ArrowRightIcon, TrophyIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full overflow-hidden" style={{
    minHeight: '520px',
    background: 'linear-gradient(135deg, #0f2318 0%, #1e3d2f 40%, #2d5a3d 80%, #1a3528 100%)'
  }} aria-label="Featured announcement" data-id="element-269">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 texture-overlay opacity-40" aria-hidden="true" data-id="element-270" />

      {/* Decorative diagonal accent */}
      <div className="absolute right-0 top-0 bottom-0 w-1/3 hidden lg:block" style={{
      background: 'linear-gradient(135deg, transparent 0%, rgba(200,168,75,0.06) 100%)',
      clipPath: 'polygon(30% 0%, 100% 0%, 100% 100%, 0% 100%)'
    }} aria-hidden="true" data-id="element-271" />

      {/* Gold top accent bar */}
      <div className="w-full h-1" style={{
      backgroundColor: '#c8a84b'
    }} aria-hidden="true" data-id="element-272" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-8 py-16 md:py-24 flex flex-col lg:flex-row items-center gap-10 lg:gap-16" data-id="element-273">
        {/* Left: Content */}
        <div className="flex-1 text-center lg:text-left" data-id="element-274">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-widest mb-6" style={{
          backgroundColor: 'rgba(200,168,75,0.15)',
          border: '1px solid rgba(200,168,75,0.4)',
          color: '#c8a84b',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-275">
            <TrophyIcon size={12} data-id="element-276" />
            Upcoming Event
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold uppercase mb-4 leading-tight" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#ffffff'
        }} data-id="element-277">
            FLSC Police Pistol
            <br data-id="element-278" />
            <span style={{
            color: '#c8a84b'
          }} data-id="element-279">
              Combat Match
            </span>
          </h1>

          <div className="flex items-center justify-center lg:justify-start gap-2 mb-6" style={{
          color: '#a0c8b0',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-280">
            <CalendarDaysIcon size={16} data-id="element-281" />
            <span className="text-base font-medium" data-id="element-282">March 12–15, 2026</span>
          </div>

          <p className="text-lg leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0" style={{
          color: '#c8d8cc',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-283">
            Compete in PPC &amp; Service divisions, win prizes, and join us for
            the Sunday banquet. Open to qualified shooters 18 and older. Don't
            miss one of FLSC's premier annual competitions.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start" data-id="element-284">
            <a href="/police-pistol-combat-match" className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded font-semibold text-base transition-all hover:opacity-90 active:scale-95" style={{
            backgroundColor: '#c8a84b',
            color: '#1a1a1a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-285">
              Full Event Details
              <ArrowRightIcon size={16} data-id="element-286" />
            </a>
            <a href="/10.html" className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded font-medium text-base border transition-all hover:bg-white/10" style={{
            borderColor: 'rgba(255,255,255,0.3)',
            color: '#e8e4d8',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-287">
              <CalendarDaysIcon size={16} data-id="element-288" />
              View Calendar
            </a>
          </div>
        </div>

        {/* Right: Event detail card */}
        <div className="w-full lg:w-80 rounded-xl overflow-hidden shadow-2xl flex-shrink-0" style={{
        border: '1px solid rgba(200,168,75,0.3)',
        backgroundColor: 'rgba(255,255,255,0.05)',
        backdropFilter: 'blur(8px)'
      }} data-id="element-289">
          <div className="px-6 py-4" style={{
          backgroundColor: '#c8a84b'
        }} data-id="element-290">
            <p className="text-xs font-bold uppercase tracking-widest" style={{
            color: '#1a1a1a',
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-291">
              Event Highlights
            </p>
          </div>
          <div className="px-6 py-5 space-y-4" data-id="element-292">
            {[{
            label: 'Dates',
            value: 'March 12–15, 2026'
          }, {
            label: 'Divisions',
            value: 'PPC & Service'
          }, {
            label: 'Eligibility',
            value: 'Qualified shooters 18+'
          }, {
            label: 'Banquet',
            value: 'Sunday — all competitors welcome'
          }, {
            label: 'Prizes',
            value: 'Pistols, rifles & more'
          }].map(({
            label,
            value
          }) => <div key={label} data-id="element-293">
                <p className="text-xs uppercase tracking-wider mb-0.5" style={{
              color: '#7a9a8a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-294">
                  {label}
                </p>
                <p className="text-sm font-medium" style={{
              color: '#e8e4d8',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-295">
                  {value}
                </p>
              </div>)}
          </div>
          <div className="px-6 pb-5" data-id="element-296">
            <a href="/police-pistol-combat-match" className="block w-full text-center py-2.5 rounded text-sm font-semibold transition-all hover:opacity-90" style={{
            backgroundColor: '#c8a84b',
            color: '#1a1a1a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-297">
              Click for Full Details
            </a>
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0" aria-hidden="true" data-id="element-298">
        <svg viewBox="0 0 1440 40" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: 'block',
        width: '100%',
        height: '40px'
      }} data-id="element-299">
          <path d="M0 40L1440 40L1440 20C1200 0 960 40 720 20C480 0 240 40 0 20L0 40Z" fill="#f8f6f0" data-id="element-300" />
        </svg>
      </div>
    </section>;
}